import { urlBase64ToUint8Array } from "common/utils/webPush";
import { showMessageModal } from "common/utils/modalController";
import { apiRequest } from "common/utils/api";
import { REQUEST_METHOD } from "common/enum/RequestMethod";
import { t } from "i18next";

const PUSH_DENIED_NOTICE_KEY = "pushDeniedNoticeShown";
const PUSH_KEY_STORAGE = "webPushApplicationServerKey";

export async function subscribeWebPush(pushKey) {
  if (!pushKey) {
    console.warn("Web Push public key not found. Skip subscription.");
    return false;
  }

  // 1. 브라우저 지원 체크
  if (!("serviceWorker" in navigator)) {
    showMessageModal(t("browserNotSupported", { ns: "webPush" }));
    return false;
  }
  if (!("PushManager" in window) || !("Notification" in window)) {
    showMessageModal(t("pushApiNotSupported", { ns: "webPush" }));
    return false;
  }

  // 2. 알림 권한 요청 및 확인
  // 이미 거부된 상태라면 굳이 팝업을 띄우지 않고 바로 알림 처리
  if (Notification.permission === "denied") {
    showDeniedModalOnce();
    return false;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    showDeniedModalOnce();
    return false;
  }

  try {
    const registration = await navigator.serviceWorker.ready;
    let subscription = await registration.pushManager.getSubscription();
    const savedPushKey = localStorage.getItem(PUSH_KEY_STORAGE);

    /** pushKey가 변경된 경우 기존 구독 해제 */
    if (subscription && savedPushKey && savedPushKey !== pushKey) {
      console.info("Push key changed. Re-subscribing...");
      await subscription.unsubscribe();
      subscription = null; // 확실하게 초기화하여 아래에서 재구독 유도
    }

    // 3. Web Push 구독 생성 (없거나 key가 바뀌어 null이 된 경우)
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(pushKey),
      });
    }

    // 4. 서버로 subscription 전달
    const res = await apiRequest({
      method: REQUEST_METHOD.POST,
      url: `/api/v1.0/web-push/subscribe`,
      body: { subscription },
    });

    if (res?.data?.code !== "0000") {
      showMessageModal(
        res?.data?.message || t("subscribeFailed", { ns: "webPush" }),
      );
      return false;
    }

    /** 성공 시 pushKey 저장 */
    localStorage.setItem(PUSH_KEY_STORAGE, pushKey);
    return true;
  } catch (e) {
    console.error("Web Push Subscription Error:", e);
    showMessageModal(
      e?.response?.data?.message || t("subscribeError", { ns: "webPush" }),
    );
    return false;
  }
}

// 중복 코드를 줄이기 위한 헬퍼 함수
function showDeniedModalOnce() {
  const alreadyShown = localStorage.getItem(PUSH_DENIED_NOTICE_KEY);
  if (!alreadyShown) {
    showMessageModal(t("permissionDenied", { ns: "webPush" }));
    localStorage.setItem(PUSH_DENIED_NOTICE_KEY, "true");
  }
}

export function clearWebPushStorage() {
  localStorage.removeItem(PUSH_KEY_STORAGE);
}
